(function () {
  var SCRIPT = document.currentScript;
  var STORAGE_KEY = 'shevchenko_market_choice';
  var currentMarket = SCRIPT.getAttribute('data-current-market');

  // Real production form — Display Timing is set to "Only show on custom
  // trigger" in Klaviyo. We call this on every visit, independent of the
  // store-switcher's own one-time-per-domain state; Klaviyo's own on-site
  // suppression (cookie-based) decides whether it actually displays to a
  // given visitor.
  var KLAVIYO_FORM_ID = 'UycecP';
  var KLAVIYO_LAST_SHOWN_KEY = 'shevchenko_klaviyo_last_shown';
  var KLAVIYO_COOLDOWN_MS = 24 * 60 * 60 * 1000; // 1 day

  function klaviyoOnCooldown() {
    try {
      var last = window.localStorage.getItem(KLAVIYO_LAST_SHOWN_KEY);
      return !!last && (Date.now() - parseInt(last, 10)) < KLAVIYO_COOLDOWN_MS;
    } catch (e) {
      return false;
    }
  }

  function openKlaviyoForm() {
    try {
      window.localStorage.setItem(KLAVIYO_LAST_SHOWN_KEY, String(Date.now()));
    } catch (e) {
      /* localStorage unavailable — cooldown just won't persist */
    }
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', KLAVIYO_FORM_ID]);
  }

  function openKlaviyoFormIfAllowed() {
    if (!klaviyoOnCooldown()) openKlaviyoForm();
  }

  function isTouchDevice() {
    return !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
  }

  // Exit-intent: wait for a signal the visitor is about to leave, rather
  // than firing shortly after they arrive. Desktop — mouse leaving through
  // the top of the viewport (toward tab bar / back button / closing the
  // tab). Touch devices have no mouse, so FALLBACK_MS gives them a long
  // time-on-page fallback instead of never firing at all. Once shown, it
  // won't be armed again for KLAVIYO_COOLDOWN_MS.
  var FALLBACK_MS = 45000;
  function armKlaviyoOnExit() {
    if (klaviyoOnCooldown()) return;
    var fired = false;
    function fire() {
      if (fired) return;
      fired = true;
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseout', onMouseOut);
      window.clearTimeout(fallbackTimer);
      openKlaviyoForm();
    }
    // Fires the moment the cursor enters the top zone while still moving
    // around the page — earlier than waiting for it to actually leave the
    // viewport, which only fires right at the very edge.
    function onMouseMove(e) {
      if (e.clientY <= 100) fire();
    }
    // Backup for fast movement that jumps straight out without an
    // intermediate mousemove near the threshold.
    function onMouseOut(e) {
      if (e.clientY <= 20 && !e.relatedTarget) fire();
    }
    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseout', onMouseOut);
    var fallbackTimer = window.setTimeout(fire, FALLBACK_MS);
  }

  function getParam(name) {
    return new URLSearchParams(window.location.search).get(name);
  }

  function setChoice(market) {
    try {
      window.localStorage.setItem(STORAGE_KEY, market);
    } catch (e) {
      /* localStorage unavailable (private mode, etc.) — popup will just show again next visit */
    }
  }

  function getChoice() {
    try {
      return window.localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return null;
    }
  }

  // Arrived here via a deliberate switch from the other store — record it,
  // strip the query param, and never show the popup for this visit.
  var arrivedFromSwitch = getParam('market');
  if (arrivedFromSwitch === currentMarket) {
    setChoice(currentMarket);
    var url = new URL(window.location.href);
    url.searchParams.delete('market');
    window.history.replaceState({}, '', url.toString());
    armKlaviyoOnExit();
    return;
  }

  if (getChoice()) {
    // Switcher already resolved on an earlier visit — Klaviyo still gets
    // its own independent chance on every visit, per its own suppression.
    armKlaviyoOnExit();
    return;
  }

  var popup = document.getElementById('store-switcher-popup');
  if (!popup) {
    armKlaviyoOnExit();
    return;
  }

  // Pre-highlight a suggestion based on browser language — visual only, never auto-redirects.
  var lang = (navigator.language || '').toLowerCase();
  var suggestedMarket = (lang.indexOf('uk') === 0 || lang.indexOf('ru') === 0) ? 'ua' : 'intl';
  var suggestedOption = popup.querySelector('[data-market="' + suggestedMarket + '"]');
  if (suggestedOption) suggestedOption.classList.add('is-suggested');

  function showPopup() {
    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');
  }

  // Short gap after the visitor just closed the switcher popup on mobile
  // — there's no mouse to detect exit-intent with, and the long
  // FALLBACK_MS is too slow right after they were just engaged.
  var MOBILE_POST_POPUP_DELAY_MS = 3000;

  function hidePopup(stayedOnThisMarket) {
    popup.hidden = true;
    popup.setAttribute('aria-hidden', 'true');
    if (stayedOnThisMarket) {
      // Only arm Klaviyo when the visitor stays on this page — if they're
      // navigating to the other store, that page isn't loaded yet.
      if (isTouchDevice()) {
        window.setTimeout(openKlaviyoFormIfAllowed, MOBILE_POST_POPUP_DELAY_MS);
      } else {
        armKlaviyoOnExit();
      }
    }
  }

  popup.querySelectorAll('[data-store-switcher-dismiss]').forEach(function (el) {
    el.addEventListener('click', function () {
      setChoice(currentMarket);
      hidePopup(true);
    });
  });

  var stayButton = popup.querySelector('[data-store-switcher-stay]');
  if (stayButton) {
    stayButton.addEventListener('click', function () {
      setChoice(currentMarket);
      hidePopup(true);
    });
  }

  // The "other market" option is a real <a href>; record the choice just
  // before navigation so a back-button return doesn't re-trigger the popup.
  var otherOption = popup.querySelector('[data-market="' + (currentMarket === 'ua' ? 'intl' : 'ua') + '"]');
  if (otherOption && otherOption.tagName === 'A') {
    otherOption.addEventListener('click', function () {
      setChoice(currentMarket);
    });
  }

  window.setTimeout(showPopup, 600);
})();
